import { useTheme } from '@material-ui/core';
import React from 'react';
import { Hexagon } from './Hexagon';

// Displays hexagonal markers showing correct/incorrect/unanswered status for each task
export const TaskMarkers = ({ active, currentRoundIndex, round, roundIndex, viewingFeedback}) => {

  const theme = useTheme();

  const isJustCompleted = (currentTaskIndex) => {
    if (active && viewingFeedback && (round[currentTaskIndex + 1] === null || typeof round[currentTaskIndex + 1] === 'undefined') )
    {
      return true;
    } 
    return false;
  }

  // Figures out the logic for task marker styling and returns it
  const displayTaskMarkers = () => {
    let prevCompleted = true;
    
    return round.map((task, j) => {

      // not completed
      let hexProps = {
        fill: 'transparent',
        stroke: theme.palette.navyLight2,
        strokeWidth: 2,
      }

      let mod = '';

      let innerText = j + 1;

      // success
      if (task) {
        hexProps = {
          fill: theme.palette.teal,
          stroke: isJustCompleted(j) ? theme.palette.navyDark3 : theme.palette.teal,
          strokeWidth: 2,
        }
        mod = 'success';
        innerText = <i className="fas fa-check"></i>
      } 
      // failure
      else if (task !== null) {
        hexProps = {
          fill: theme.palette.pink,
          stroke: isJustCompleted(j) ? theme.palette.navyDark3 : theme.palette.pink,
          strokeWidth: 2,
        }
        mod = 'failure';
        innerText = <i className="fas fa-times"></i>
      } 
      // active
      else if (active && currentRoundIndex === roundIndex && prevCompleted && !viewingFeedback) {
        hexProps = {
          fill: 'transparent',
          stroke: theme.palette.navyDark3,
          strokeWidth: 3,
        }
        prevCompleted = false;
        mod = 'active';
      } 

      return (
        <li key={j} className={`hexagon task-markers__task ${mod ? `task-markers__task--${mod}` : ''}`}>
          <Hexagon {...hexProps}>{innerText}</Hexagon>
        </li>
      )
    })
  }

  return (
    <ol className="task-markers__round">
      {
        displayTaskMarkers()
      }
    </ol>
  )
}